import { useState } from 'react'
import Helmet from 'react-helmet'
import Banner from '../../components/Banner'
import ContactForm from '../../components/ContactForm'
import CheckIcon from '../../assets/icons/CheckIcon'
import TimesIcon from '../../assets/icons/TimesIcon'
import CapacityIcon from '../../assets/icons/CapacityIcon'
import FoodIcon from '../../assets/icons/FoodIcon'
import LaptopIcon from '../../assets/icons/LaptopIcon'
import NatureIcon from '../../assets/icons/NatureIcon'
import RingIcon from '../../assets/icons/RingIcon'
import classNames from 'classnames'
import WhatsAppButton from '../../components/WhatsAppButton'
import ImageCorporate1 from '../../assets/events/corporate/corporate-1.webp'
import ImageCorporate2 from '../../assets/events/corporate/corporate-2.webp'
import ImageCorporate3 from '../../assets/events/corporate/corporate-3.webp'
import ImageCorporate4 from '../../assets/events/corporate/corporate-4.webp'
import ImageCorporate5 from '../../assets/events/corporate/corporate-5.webp'
import ImageCorporate6 from '../../assets/events/corporate/corporate-6.webp'
import ImageSocial1 from '../../assets/events/social/social-1.webp'
import ImageSocial2 from '../../assets/events/social/social-2.webp'
import ImageSocial3 from '../../assets/events/social/social-3.webp'
import ImageSocial4 from '../../assets/events/social/social-4.webp'
import ImageSocial5 from '../../assets/events/social/social-5.webp'
import ImageSocial6 from '../../assets/events/social/social-6.webp'
import ImageSocial7 from '../../assets/events/social/social-7.webp'


const OPTIONS = ['all', 'corporate', 'social']
const TYPES = {
  all: 'Todos',
  corporate: 'Corporativos',
  social: 'Sociales'
}
const EVENTS = [
  {
    title: 'After office',
    type: 'corporate',
    caption: ' Espacios que Inspiran Conexiones',
    description: 'Un encuentro informal después de la jornada laboral, es el momento ideal para fomentar la interaccion entre colegas en un ambiente relajado con música, tragos y aperitivos.',
    benefits: [
      'Fortalecer el vinculo entre compañeros.',
      'Distención del equipo.',
      'Transformar una tarde común en una experiencia memorable.'
    ],
    image: ImageCorporate1,
  }, {
    title: 'Conferencias',
    type: 'corporate',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Encuentros profesionales donde se comparten ideas, se toman decisiones y se coordinan acciones en un entorno cómodo y equipado.',
    benefits: [
      'Comunicación clara y directa.',
      'Toma de decisiones rápida.',
      'Fomento del trabajo en equipo.',
      'Resolución de problemas en el momento.',
      'Fortalecimiento de vínculos laborales.'
    ],
    image: ImageCorporate2,
  },
  {
    title: 'Presentaciones',
    type: 'corporate',
    'caption': 'Espacios que Inspiran Conexiones',
    description: 'Espacio ideal para mostrar libros, productos o servicios de forma profesional y cercana, generando impacto directo en el público.',
    benefits: [
      'Ambiente controlado y sin distracciones.',
      'Interacción directa con los asistentes.',
      'Posibilidad de mostrar demos o ejemplares.',
      'Feedback inmediato.',
      'Clima íntimo que fortalece el vínculo con la marca o autor/a.'
    ],
    image: ImageCorporate3,
  },
  {
    title: 'Eventos empresariales',
    type: 'corporate',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Reuniones estratégicas organizadas por empresas para comunicar, capacitar o fortalecer vínculos. Incluyen conferencias, lanzamientos de productos, capacitaciones o networking. Requieren una planificación impecable en locación, tecnología, catering y ambientación alineada a la identidad de la empresa.',
    benefits: [
      'Motiva y fidelizar a tus empleados.',
      'Impulsa la comunicación interna.',
      'Refuerza la cultura de la empresa.'
    ],
    image: ImageCorporate4,
  },
  {
    title: 'Workshops',
    type: 'corporate',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Seminarios intensivos con enfoque práctico y participativo, donde los asistentes experimentan y aplican conocimientos en el momento. Se realizan en entornos inspiradores y  presenciales.',
    benefits: [
      'Aprendizaje activo.',
      'Networking.',
      'Potenciar habilidades.'
    ],
    image: ImageCorporate5,
  },
  {
    title: 'Fin de año',
    type: 'corporate',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Un evento clave para empresas y organizaciones, donde se celebra el cierre del año con empleados y directivos. Incluye cena, reconocimientos y sorteos, todo en un ambiente festivo y motivador.',
    benefits: [
      'Crea nuevos vínculos entre colegas.',
      'Fortalece el clima laboral.',
      'Renueva energía'
    ],
    image: ImageCorporate6,
  },
  {
    title: 'Casamientos',
    type: 'social',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Celebración del amor con detalles personalizados que reflejan la esencia de la pareja. Puede ser clásico, boho, rústico o moderno, con una planificación minuciosa en locación, decoración, catering, música y momentos inolvidables.',
    benefits: [
      'Celebrar el amor y el compromiso.',
      'Generar recuerdos inolvidables.',
      'Fortalece los vínculos familiares y amistosos.'
    ],
    image: ImageSocial1,
  },
  {
    title: 'Jornadas de yoga',
    type: 'social',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Encuentros dedicados al bienestar y la conexión cuerpo-mente-alma. Se realizan en espacios naturales o salones tranquilos, con sesiones de yoga, meditación, alimentación saludable y actividades holísticas.',
    benefits: [
      ' Conexión cuerpo-mente-alma.',
      ' Reducción de estrés y ansiedad.',
      'Espacio de introspección.'
    ],
    image: ImageSocial2,
  },
  {
    title: 'Cumpleaños de 15 ',
    type: 'social',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Un evento único para la quinceañera, con recepción elegante, entrada especial, vals, show de baile, temáticas personalizadas y una fiesta espectacular con DJ y luces.',
    benefits: [
      'Crea recuerdos inolvidables.',
      'Genera conexión con las personas más importantes de tu vida.',
      'Marca simbólicamente el paso del tiempo.'
    ],
    image: ImageSocial3,
  },
  // {
  //   title: 'Fiestas',
  //   type: 'social',
  //   caption: 'Espacios que Inspiran Conexiones',
  //   description: 'Celebraciones de cumpleaños, aniversarios, despedidas o cualquier ocasión especial. Pueden ser el motivo para festejar, con música, tragos, catering y ambientación única.',
  //   benefits: [
  //     'Crear recuerdos emotivos.',
  //     'Disfrutar, bailar y reir.',
  //     'Reunir a quienes te quieren en un solo lugar.'
  //   ],
  //   image: ImageSocial4,
  // },
  {
    title: 'Sunsets',
    type: 'social',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Eventos al aire libre en el atardecer, con música chill o electrónica, cócteles y una ambientación relajada con livings. Ideales para networking o celebraciones informales.',
    benefits: [
      'Ideal para conectar sin tanta estructura.',
      'Bellos atardeceres, música suave y tragos estupendos.'
    ],
    image: ImageSocial5,
  },
  {
    title: 'Ferias',
    type: 'social',
    caption: 'Espacios que Inspiran Conexiones',
    description: 'Espacios dinámicos para exhibición y venta de productos, emprendimientos o arte. Pueden ser gastronómicas, de diseño, sustentables o culturales, con stands, food trucks y actividades interactivas.',
    benefits: [
      'Generan comunidad.',
      'Espacio de diversidad y creatividad.',
      'Experiencia para toda la familia.'
    ],
    image: ImageSocial6,
  },
  // {
  //   title: 'Infantiles',
  //   type: 'social',
  //   caption: 'Espacios que Inspiran Conexiones',
  //   description: 'Cumpleaños, bautismos o fiestas temáticas para los más pequeños. Se enfocan en la diversión con juegos, animación, inflables, estaciones de dulces y decoraciones coloridas.',
  //   benefits: [
  //     'Crear recuerdos felices.',
  //     'Compartes la celebración en familia.',
  //     'Momento de conexión con sus pares.'
  //   ],
  //   image: ImageSocial7,
  // }
]
const ITEMS = [
  {
    title: 'Gastronomía de excelencia',
    description: 'Trabajamos con proveedores de primer nivel para ofrecer opciones gastronómicas que se alineen con tus preferencias y estilo de vida.',
    icon: <FoodIcon width={40} height={40} className='text-orange'/>
  }, {
    title: 'Experiencias personalizadas',
    description: 'Ofrecemos servicios adicionales para elevar cada celebración: decoración, fotografía, cotillón, glitter make-up y más. Consultá por nuestras opciones.',
    icon: <CapacityIcon width={40} height={40} className='text-orange'/>
  }, {
    title: 'Entorno natural exclusivo',
    description: 'Disponemos de un espacio verde de 500 m² equipado con todas las comodidades: quincho, parrilla y mobiliario de alta calidad, en un entorno que invita a la desconexión y el disfrute.',
    icon: <NatureIcon width={40} height={40} className='text-orange'/>
  }, {
    title: 'Atención y asistencia continua',
    description: 'Nuestro equipo está presente durante todo el evento, brindando recepción, asistencia y servicio de limpieza para asegurar una experiencia impecable.',
    icon: <RingIcon width={40} height={40} className='text-orange'/>
  }, {
    title: 'Tecnología de vanguardia',
    description: 'Todos nuestros espacios cuentan con conexión Wifi de alta velocidad y un sistema de respaldo de emergencia para garantizar un evento sin interrupciones.',
    icon: <LaptopIcon width={40} height={40} className='text-orange'/>
  }
]


const Events = () => {
  const [ selectedOption, setSelectedOption ] = useState(OPTIONS[0])
  const [ eventModal, setEventModal ] = useState({
    event: null,
    show: false
  })

  return (
    <>
      <Helmet>
        <title>Vida Cowork: Eventos</title>
      </Helmet>
      <main className="Events">
        <Banner
          title='Eventos'
          description='Somos versátiles y detallistas, queremos que tu evento salga tal como lo soñaste.'
          message='¡Hola! Quisiera realizar un evento en Vida'
          whatsappIconLeft
          contact='5493513998318'
        />

        {/* Info */}
        <section className="Events__List container-custom">
          <div className="d-flex flex-column gap-2 text-green">
            <span className="text-2 fw-semibold">Tipos de eventos</span>

            <div className="d-flex align-items-center gap-3">
              {OPTIONS.map((option, index) => (
                <button
                  key={`Event-Type-${index}`}
                  className="Events__Type"
                  onClick={() => setSelectedOption(option)}
                >
                  <div
                    className={classNames(
                      { 'Events__Checkbox': selectedOption !== option },
                      { 'Events__Checkbox--Active': selectedOption === option },
                    )}
                  >
                    <CheckIcon width={14} height={14} className='text-white'/>
                  </div>
                  <span className='text-4'>{TYPES[option]}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="Events__Grid">
            {EVENTS
              .filter((event) => {
                if(selectedOption === 'all') return event
                return event.type === selectedOption
              })
              .map((event, index) => (
                <button
                  key={`Event-Card-${index}`}
                  className={classNames(
                    'Events__Card',
                    { 'active': JSON.stringify(event) === JSON.stringify(eventModal.event) }
                  )}
                  onClick={() => setEventModal({ event, show: true })}
                >
                  <img
                    src={event.image}
                    alt={event.title}
                    title={event.title}
                  />

                  <span className={classNames('text-2 fw-bold text-green py-2', {
                    'text-white': JSON.stringify(event) === JSON.stringify(eventModal.event)
                  })}>
                    { event.title}
                  </span>
                </button>
              ))}
          </div>
        </section>

        <section className='Events__Info container-custom'>
          <div className="Events__Info-Title d-flex flex-column gap-2">
            <span className="caption text-green">
              Planificación y organización profesional
            </span>
            <span className='text-3 text-gray-dark'>Nuestro equipo, especializado en Organización de Eventos, diseña y coordina cada detalle de la celebración, adaptándonos a tus necesidades y objetivos.</span>
          </div>

          <div className="Events__Info-Grid">
            {ITEMS.map((item, index) => (
              <div
                key={`Event-Info-Item-${index}`}
                className="Events__Info-Item"
              >
                { item.icon }
                <div className="d-flex flex-column gap-2">
                  <p className="text-3 fw-medium text-orange">
                    { item.title }
                  </p>
                  <p className="text-4 text-gray-dark">
                    { item.description }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Form */}
        <ContactForm/>

        {eventModal.show && (
          <div
            className="Events__Modal-Container"
            onClick={() => setEventModal({ event: null, show: false })}
          >
            <div
              className="Events__Modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className='Events__Modal-Close'
                onClick={() => setEventModal({ event: null, show: false })}
              >
                <TimesIcon/>
              </button>

              <div className="Events__Modal-Content">
                <div className="Events__Modal-Title">
                  <span className="caption text-green">
                    { eventModal.event.title }
                  </span>
                  <span className="text-3 text-gray-dark fw-semibold">
                    { eventModal.event.caption }
                  </span>
                </div>

                <div className="Events__Modal-Description">
                  <div className="d-flex flex-column gap-1">
                    <span className="text-3 fw-semibold">
                      Descripción
                    </span>
                    <span className="text-5 text-gray-dark">
                      { eventModal.event.description }
                    </span>
                  </div>

                  <div className="d-flex flex-column gap-1">
                    <span className="text-3 fw-semibold">
                      Beneficios
                    </span>
                    <ul className='text-5'>
                      { eventModal.event.benefits.map((benefit, index) => (
                        <li key={`Event-Benefit-${index}`}>{ benefit }</li>
                      ))}
                    </ul>
                    <WhatsAppButton
                      label="Reservar ahora"
                      message={`¡Hola! Quisiera realizar un evento "${eventModal.event.title}" en Vida`}
                      contact='5493513998318'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  )
}

export default Events
